import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

/**
 * add context to Datadog RUM and logs
 *
 * @param {array} contextArray
 */
export function addContext(contextArray) {
  contextArray.forEach(context => {
    const { key, value } = context;

    if (window.DATADOG_RUM_ENABLED) {
      datadogRum.setGlobalContextProperty(key, value);
    }
    if (window.DATADOG_LOGS_ENABLED) {
      datadogLogs.setGlobalContextProperty(key, value);
    }
  });
}

/**
 * remove context from Datadog RUM and logs
 *
 * @param {array} contextArray
 */
export function removeContext(contextArray) {
  contextArray.forEach(context => {
    const { key } = context;

    if (window.DATADOG_RUM_ENABLED) {
      datadogRum.removeGlobalContextProperty(key);
    }
    if (window.DATADOG_LOGS_ENABLED) {
      datadogLogs.removeGlobalContextProperty(key);
    }
  });
}
